import { ClientAPIManagement } from "@/components/ClientAPIManagement";
import { useNavigate } from "react-router-dom";

export const ClientApiPage = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/");
  return <ClientAPIManagement onBack={handleBack} />;
};
